module.exports = __webpack_public_path__ + "front/img/s1.8447ebc8.png";